const defaultTabIndex = {
  id: 0,
  name: 'card',
};

export const loadState = () => {
	try {
		const serializedState = localStorage.getItem('exP_H2yUymTAWw');

		if (serializedState === null) {
			return undefined;
		}

		let loadedState = JSON.parse(serializedState);

		if (!loadedState.settings['tabIndex']) {
		  loadedState = {
        ...loadedState,
        settings: {
          ...loadedState.settings,
          tabIndex: defaultTabIndex,
        }
      };
    }

		return loadedState;
	} catch (err) {
		return undefined;
	}
};

export const saveState = (state) => {
	try {
		const serializedState = JSON.stringify({
      ...state,
      settings: {
        ...state.settings,
        tabIndex: defaultTabIndex,
      }
    });

		localStorage.setItem('exP_H2yUymTAWw', serializedState);
	} catch (err) {
		new Error('Cannot save the state');
	}
};



// WEBPACK FOOTER //
// ./src/localStorage.js